import React from 'react'
import { Heading } from 'goustouicomponents/dist/Heading'
import css from './Glassdoor.module.css'

const Glassdoor = () => (
  <section>
    <div className={css.container}>
      <div>
        <Heading type="h2" size="fontStyleXL" isCenter>
          &quot;Fast-paced business with lots of opportunities to learn&quot;
        </Heading>
        <a
          href="https://www.glassdoor.com/Overview/Working-at-Gousto-EI_IE1319027.11,17.htm"
          target="_blank"
          rel="noreferrer noopener"
        >
          <div className={css.glassdoorRatingImg} role="img" area-label="Glassdoor logo" />
        </a>
      </div>
    </div>
  </section>
)

export { Glassdoor }
